import StateObserver from 'src/StateObserver';
import { getGameScene } from '../game/getGameScene';
import { hasValidSaveState } from 'src/replicant/match2/savestate/match2-savestate.getters';
import {
  SaveStateOrigin,
  decodeSaveStateData,
  encodeSaveStateData,
} from './match2-savestate.data';
import { trackSessionStateLoad } from 'src/game/crossplay/crossplay.tracking';
import { GCInstant } from 'src/lib/gcinstant';
import { track } from 'src/lib/analytics/utils';

/**
 * Save current gameplay state. If set, forceLevel will override current scene level.
 */
export async function saveMatch2GameplayState(
  origin: SaveStateOrigin,
  forceLevel?: number,
) {
  // Only save if user is playing match2 game or if the save state is triggered by a cheat
  const user = StateObserver.getState().user;
  if (!user.match2.playing && origin !== 'cheat') return;

  // Only save if match2 scene is active
  const scene = getGameScene();
  if (!scene) return;

  const dataObj = scene.sessionSystem.getSaveStateData();
  if (!dataObj) return;

  const level = forceLevel ?? scene.level;

  const dataStr = encodeSaveStateData(dataObj);
  await StateObserver.invoke.saveMatch2GameplayState({
    level,
    data: dataStr,
  });
}

/**
 * Load existing save state, if there are any
 */
export function loadMatch2GameplayState() {
  const user = StateObserver.getState().user;
  const now = StateObserver.now();

  if (!user.match2.saveState) return undefined;
  if (!hasValidSaveState(user, now)) return undefined;

  track('Match2LoadState', {
    level: user.match2.level,
  });

  const crossplayTracking =
    GCInstant.entryData.crossplayTracking ?? ({} as any);

  trackSessionStateLoad(crossplayTracking);

  const data = decodeSaveStateData(user.match2.saveState.data);

  return data;
}

/**
 * Clear existing save state, if there are any
 */
export function clearMatch2GameplayState() {
  // Skip if there is no save state available
  if (!StateObserver.getState().user.match2.saveState) return;
  // Delete existing save state
  void StateObserver.invoke.clearMatch2GameplayState();
}
